module.exports = __webpack_public_path__ + "static/cases-tile-4-1-62a65d9bb7954c58b7cb74e43a091991.png";